import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { isChunkLoadError, recoverFromChunkLoad, clearChunkReloadGuard } from '@/utils/chunkReload';

// Global error handling with chunk load failure recovery
window.addEventListener('unhandledrejection', event => {
  const message = event.reason?.message || String(event.reason);

  // Detect chunk/module load failures (stale deployment)
  if (isChunkLoadError(message)) {
    console.warn('Chunk load failed, reloading page for fresh assets:', message);
    recoverFromChunkLoad();
    return;
  }

  console.warn('Unhandled promise rejection prevented:', event.reason);
  event.preventDefault();
});

// Global error handling for script loading failures
window.addEventListener(
  'error',
  event => {
    const message = event.message || '';

    // Detect script loading failures (stale chunk references)
    if (
      isChunkLoadError(message) ||
      (event.target instanceof HTMLScriptElement && event.target.src.includes('/assets/'))
    ) {
      console.warn('Script load failed, reloading page:', message);
      recoverFromChunkLoad();
      return;
    }

    console.warn('Global error caught:', event.error);
  },
  true,
); // Use capture phase to catch script errors

// Once assets have loaded successfully, reset the reload guard so a later
// stale-chunk error in the same session gets its own fresh retry budget.
window.addEventListener('load', clearChunkReloadGuard);

createRoot(document.getElementById('root')!).render(<App />);
